export const AUTH_BYPASS =
  process.env.NODE_ENV === "development" &&
  process.env.REACT_APP_AUTH_BYPASS === "1";

export const BYPASS_FAKE_TOKEN = "bypass-token";
